interface SuggestionConfig {
  default: number;
}
interface MaxQuickLinkSuggestionConfig {
  default: number;
  withProducts: number;
}

interface MaxProductSuggestionConfig {
  default: number;
  withQuickLinks: number;
}

interface SuggestionConfiguration {
  maxSuggestions: {
    config: SuggestionConfig;
  };

  maxQuickLinkSuggestions: {
    config: MaxQuickLinkSuggestionConfig;
  };

  maxProductSuggestions: {
    config: MaxProductSuggestionConfig;
  };
}

export const suggestionConfiguration: SuggestionConfiguration = {
  maxSuggestions: {
    config: {
      default: 6,
    },
  },
  maxProductSuggestions: {
    config: {
      default: 3,
      withQuickLinks: 3,
    },
  },
  maxQuickLinkSuggestions: {
    config: {
      default: 5,
      withProducts: 3,
    },
  },
};
